import React from 'react';
import { FormGroup, Input } from 'reactstrap';
import TableRow from '@material-ui/core/TableRow';
import { toggleCheckedItemById } from '../../redux/actions';
import TableCell from '@material-ui/core/TableCell';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import * as Constants from '@/shared/helpers/constants';

const AssignTableRow = ({ data, orgData }) => {
  const dispatch = useDispatch();
  const { activeTab, checkedItemIds } = useSelector(
    (state) => state.cadsAIAssignPage,
    shallowEqual,
  );

  const handleOnChange = (itemId) => {
    dispatch(toggleCheckedItemById(itemId));
  };

  const renderUserCells = (user) => {
    const id = user?.id;
    return (
      <>
        <TableCell align="center" className="material-table__cell">
          <FormGroup>
            <Input
              type="checkbox"
              value={id}
              checked={checkedItemIds.includes(id)}
              onChange={() => handleOnChange(id)}
            />
          </FormGroup>
        </TableCell>
        <TableCell align="center" className="material-table__cell">
          {user?.userName}{' '}
        </TableCell>
        <TableCell align="center" className="material-table__cell">
          {user?.email}{' '}
        </TableCell>
      </>
    );
  };

  const renderCohortCells = (cohort) => (
    <>
      <TableCell align="center" className="material-table__cell">
        <FormGroup>
          <Input
            type="checkbox"
            value={cohort?.id}
            checked={checkedItemIds.includes(cohort?.id)}
            onChange={() => handleOnChange(cohort?.id)}
          />
        </FormGroup>
      </TableCell>
      <TableCell align="center" className="material-table__cell">
        {cohort?.title}{' '}
      </TableCell>
    </>
  );

  function renderOrgCells(organization) {
    const id = organization?.id;
    return (
      <>
        <TableCell align="center" className="material-table__cell">
          <FormGroup>
            <Input
              type="checkbox"
              value={id}
              checked={checkedItemIds.includes(id)}
              onChange={() => handleOnChange(id)}
            />
          </FormGroup>
        </TableCell>
        <TableCell align="center" className="material-table__cell">
          {organization?.title}{' '}
        </TableCell>
      </>
    );
  }

  return (
    <>
      {
        {
          [Constants.USERS]: data?.map((d) => (
            <TableRow className="material-table" tabIndex={-1} key={d.id}>
              {renderUserCells(d)}
            </TableRow>
          )),
          [Constants.COHORT]: data?.map((d) => (
            <TableRow className="material-table" tabIndex={-1} key={d.id}>
              {renderCohortCells(d)}
            </TableRow>
          )),
          [Constants.ORGANIZATION]: orgData?.map((d) => (
            <TableRow className="material-table" tabIndex={-1} key={d.organizationId}>
              {renderOrgCells(d)}
            </TableRow>
          )),
        }[activeTab]
      }
    </>
  );
};

export default AssignTableRow;
